import classNames from 'classnames';
import { type HTMLAttributes, memo } from 'react';

/**
 * @deprecated This component is deprecated and will be removed post UI2
 */
export const ContentHeaderTitle = memo(({ className, ...props }: HTMLAttributes<HTMLHeadElement>) => {
  return (
    <h1
      className={classNames(
        'my-[6px] mr-4 break-words font-semibold ads:text-primary text-24 text-pigeon-700',
        className,
      )}
      data-disableselect="true"
      {...props}
    />
  );
});

ContentHeaderTitle.displayName = 'ContentHeaderTitle';
